import React  from "react";
import { useParams } from "react-router-dom";
import {Helmet} from 'react-helmet-async'
import { NavIn } from '../components/componentNav/NavIn'
import { EpigraphKarman,LasttitleKarman,NameKarman,TitleKarman } from "../components/ComponentCartBy/inComponent/KarmanEast";
import { KarmanWest } from "../components/ComponentCartBy/inComponent/KarmanWest";
import effect from "../card/effect3.json";

export function UnderWest() {
  window.scrollTo(0,0);
  const params  = useParams();
  let array = effect.find(item => item.slug === params.ID);

  function lookImgHtml( look )  {
    if ( look[0] === "NaN"){
      return "https://coronadosdelbien.com/HD48.ico"
    }else{
      return "https://coronadosdelbien.com/"+look
    }
  }
  const SeoObjet = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    headline: `${array.name}`,
    description: `${array.title +" "+ array.lasttitle}`,
    keywords: `${array.keywords}`,
    image:[ `${lookImgHtml(array.img.slice(0,1))}`],
    datePublished: new Date(`${array.Datatime}`).toISOString(),
    author: [{
      "@type" : "Person",
      name : "C.M.I",
      jobTitle: "programmer",
      url : "https://x.com/@GlassDroom"
    }],
    publisher:[
      {
        "@type":"Organization",
        name: "Droommk12",
        url: "Droommk12@Gmail.com"
      }
    ],
    url: `https://www.coronadosdelbien.com/Super/${array.slug}`,
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(SeoObjet)}</script>
      </Helmet>
      <div style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
        <NavIn props ={array}/>
        <NameKarman props={array} /> 
        <TitleKarman props={array} />
        <LasttitleKarman props={array} />
        <EpigraphKarman props={array} />
        <KarmanWest props={array} />
      </div>
      <br />
    </>
  );
}
